export default "__VITE_ASSET__BqW2hXY2__"